import { useMemo } from 'react';
import { useDateTimeLocalizationInfo, useTimezone } from '@mews/framework';
import { getBookablePeriodsDiffs } from './bookablePeriods';

export const useNewReservationBookablePeriodsDiffs = (
    arrivalDate: string,
    departureDate: string,
    arrivalHours: string,
    departureHours: string,
    isDayUse: boolean
) => {
    const timezone = useTimezone();
    const localizationInfo = useDateTimeLocalizationInfo();

    return useMemo(
        () =>
            getBookablePeriodsDiffs(
                arrivalDate,
                departureDate,
                arrivalHours,
                departureHours,
                timezone,
                localizationInfo,
                isDayUse
            ),
        [arrivalDate, arrivalHours, departureDate, departureHours, localizationInfo, timezone, isDayUse]
    );
};
